<script setup>
import { reactive } from 'vue';
import { Form } from 'vee-validate';
import FormInputCheckbox from '../fields/FormInputCheckbox.vue';
import * as yup from 'yup';
import { checkboxValidation } from '../utils/validations';

const emit = defineEmits(['advance-step']);

const props = defineProps({
    formData: {
        type: Object,
        required: true
    },
    insurer: {
        type: Object,
        required: true
    }
});

const fields = reactive({
    acceptMedicalConsent1: false,
    acceptMedicalConsent2: false,
    ...props.formData
});

const submit = (values) => {
    console.log(values);
    emit('advance-step', values);
};

const schema = yup.object({
    acceptMedicalConsent1: checkboxValidation,
    acceptMedicalConsent2: checkboxValidation
});
</script>
<template>
    <Form :validation-schema="schema" @submit="submit">
        <h2 class="panel-heading h2">Life Insured Health Information Consent</h2>

        <div class="form-panel">
            <div class="wysiwyg-output">
                <p>I/We agree</p>
                <p class="tw-font-bold">
                    Authority 1 – to release any of my health information except the consultation
                    notes held by my General Practitioner/Practice
                </p>
                <p>
                    With the exception of consultation notes held by any General
                    Practitioner/Practice I have attended, I authorise any health provider,
                    practitioner, practice, psychologist, dentist, allied health services provider
                    or any hospital to access and release, in writing or verbally, any details of my
                    health information to Zurich Australia Limited ('Zurich'), or to third parties
                    they engage.
                </p>
                <p>I agree to all of the following:</p>
                <ul>
                    <li>
                        My health information can be released in the form Zurich asks for, such as a
                        general report, a report about a specific condition, my records in
                        SafeScript, any hospital notes, or correspondence between health providers.
                    </li>
                    <li>
                        Zurich can collect, use, store and disclose my personal information
                        (including sensitive information) in accordance with privacy laws and
                        Australian Privacy Principles.
                    </li>
                    <li>
                        This Authority is valid only while Zurich is assessing my claim or
                        application for cover, or is verifying disclosures I made in connection with
                        the cover.
                    </li>
                    <li>
                        A copy or transcript of this Authority will be valid and effective, and this
                        Authority should be accepted as valid and effective where I have signed
                        electronically or consented verbally.
                    </li>
                </ul>
            </div>

            <FormInputCheckbox
                class="tw-mt-6 sm:tw-mt-10"
                name="acceptMedicalConsent1"
                label=" I, the Life Insured, confirm that I have read and accept the above health information consent Authority 1.*"
                :value="fields.acceptMedicalConsent1"
            />

            <div class="wysiwyg-output tw-mt-14">
                <p class="tw-font-bold">
                    Authority 2 – to release a copy of the full record, including consultation
                    notes, held by my General Practitioner/Practice in specified circumstances
                </p>
                <p>
                    I authorise any General Practitioner/Practice I have attended to release a copy
                    of my full record, including consultation notes, to Zurich, or to third parties
                    they engage, only if Zurich Australia Limited ('Zurich') has asked them for a
                    report on my health and either:
                </p>
                <ul>
                    <li>
                        The General Practitioner/Practice will be unable to, or did not, provide the
                        report within four weeks; or
                    </li>
                    <li>The report is incomplete, or contains inconsistencies or inaccuracies.</li>
                </ul>
                <p>I agree to all the following:</p>
                <ul>
                    <li>
                        Zurich can collect, use, store and disclose my personal information
                        (including sensitive information) in accordance with privacy laws and
                        Australian Privacy Principles.
                    </li>
                    <li>
                        This Authority is valid only while Zurich is assessing my claim or
                        application for cover, or is verifying disclosures I made in connection with
                        the cover.
                    </li>
                    <li>
                        A copy or transcript of this Authority will be valid and effective, and this
                        Authority should be accepted as valid and effective where I have signed
                        electronically or consented verbally.
                    </li>
                </ul>
            </div>

            <FormInputCheckbox
                class="tw-mt-6 sm:tw-mt-10"
                name="acceptMedicalConsent2"
                label=" I, the Life Insured, confirm that I have read and accept the above health information consent Authority 2.*"
                :value="fields.acceptMedicalConsent2"
            />
        </div>

        <button class="btn btn--green btn--full">Next</button>
    </Form>
</template>
